<mwp-card-content-header contentTitleMwp="Today's Reports" />
<div class="content-container">
    <div class="title">
        <mwp-text-translate text="Reports" jsonKey="reports" />
    </div>
    <div class="content">
        <mwp-report-history-table [reports]="reports" />
    </div>
</div>